<template>
  <ListDropdown
    v-if="options"
    class="page-length-selector"
    :value="currentPageLength.toString()"
    :options="options"
    @select="onSelect"
  />
</template>

<script setup lang="ts">
import { withDefaults, computed } from 'vue';
import type { FilterOptions } from '@i22-td-smarthome/component-library/dist/components/dropdown/list-dropdown';
import { ListDropdown } from '@i22-td-smarthome/component-library';

type PageLengthSelectorProps = {
  currentPageLength: number;
  pageLengths?: number[];
  promotedOfferSpace?: number;
};

const props = withDefaults(defineProps<PageLengthSelectorProps>(), {
  promotedOfferSpace: 0,
  pageLengths: () => [48, 98],
});

const emit = defineEmits<{
  (e: 'change', value: string): void;
}>();

const options = computed<FilterOptions[] | undefined>(() => {
  if (!props.pageLengths) return undefined;
  return props.pageLengths.map((pageLength) => {
    const size = pageLength - props.promotedOfferSpace;
    return {
      value: size.toString(),
      label: size.toString(),
    };
  });
});

const onSelect = (pageLength: string) => {
  emit('change', pageLength);
};

defineExpose({
  options,
});
</script>

<style lang="scss" scoped>
.page-length-selector {
  :deep(.dropdown-container) {
    width: 150px;
  }
}
</style>
